<template>
  <div
    class="d-flex flex-nowrap"
    v-if="$vuetify.display.width > 1560"
  >
    <div
      :key="`top_mainInstances_item_${i}`"
      v-for="(item, i) in items"
    >
      <v-btn @click="$emit('item-click', item)"
             class="text-h6 text-uppercase text-white px-sm-6"
             type="text"
             v-if="item.router"
      >
        {{ item.title }}
      </v-btn>
      <v-btn
        :href="item.href"
        type="text"
        class="text-h6 text-uppercase text-white px-sm-6"
        target="_blank"
        v-else
      >
        {{ item.title }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopMenuTopMenu',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ['item-click']
}
</script>
